<script lang="ts">
    export let big: boolean = false;
    export let height: string = big ? "6rem" : "2rem";
    export let fill_header: boolean = false;
</script>

<div class="gap" style="--height:{fill_header ? '8rem' : height}" />

<style lang="scss">
    @import "./src/vars";
    .gap {
        height: var(--height);
    }
</style>
